import React, { Component } from 'react'
import Grid from "../../../../Utils/Grid";
import { TableHeaderColumn } from "react-bootstrap-table";
import { standardActions } from "../../../../Utils/Grid/StandardActions";
import Card from "Utils/Cards/Card"
import Header from "Utils/Grid/Header";
import { formatearKG } from '../../../../Utils/renderField/renderReadField';
import './Packing.css'

export default class PackingList extends Component {
    componentDidMount() {
        const { listar, page } = this.props;
        listar(page);
    }

    render() {
        const { listar: onPageChange, onSortChange, eliminar } = this.props; //Funciones
        const { data, loader, page } = this.props; //Constantes


        return (
            <div className="mb-4 col-12 lista-empaques">
                <Card
                    icon="configuraciones_activo.png"
                    titulo="EMAPQUE"
                    subtitulo="Entre Ríos">
                    <Header to="packing/crear" textBtn="CREAR EMPAQUE" {...this.props} />
                    <Grid hover striped data={data} loading={loader} onPageChange={onPageChange} onSortChange={onSortChange}
                        page={page}>
                        <TableHeaderColumn
                            dataField="id"
                            dataAlign="center"
                            dataSort
                            width='20%'
                            dataFormat={standardActions({ editar: "packing", eliminar })}
                        />
                        <TableHeaderColumn
                            isKey
                            dataField="name"
                            dataSort
                        >
                            NOMBRE
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="storage_capacity"
                            dataSort
                            dataFormat={formatearKG}
                        >
                            CAPACIDAD DE ALMACENAMIENTO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="type_of_product"
                            dataSort
                            dataFormat={(cell, row) => cell.name}
                        >
                            PRODUCTO
                        </TableHeaderColumn>
                    </Grid>
                </Card>
            </div>
        )
    }
}
